import React, { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Tab, TabContainer, TabPanel } from 'yankees-react-utils';
import OverallTab from './OverallTab';
import Attack2kTab from './Attack2kTab';
import ByCountTab from './ByCountTab';

const StyledTabsWrapper = styled.div`
    > div > div {
        top: 4px;
    }
    
    > div > div + div {
        margin: 0;
        border: 1px solid rgb(188, 200, 209);
        border-radius: 0 0.25rem 0.25rem 0.25rem;
    }
`;

const PitchTabs = ({ className, isLoading, pitchTypes, isLhp, isLoadingAvg }) => {
    const { t: translate } = useTranslation();

    const tabs = [{
        key: 'overall',
        title: translate('sections.reports.pitcher.overall'),
        component: () => (
            <OverallTab
                isLoading={isLoading}
                pitchTypes={pitchTypes}
                isLhp={isLhp}
                isLoadingAvg={isLoadingAvg}
            />
        ),
    }, {
        key: 'attack2k',
        title: translate('sections.reports.pitcher.pitchcomparison.attack2k'),
        component: () => (
            <Attack2kTab
                isLoading={isLoading}
                pitchTypes={pitchTypes}
                isLhp={isLhp}
                isLoadingAvg={isLoadingAvg}
            />
        ),
    }, {
        key: 'bycount',
        title: translate('sections.reports.pitcher.pitchcomparison.bycount'),
        component: () => (
            <ByCountTab
                isLoading={isLoading}
                pitchTypes={pitchTypes}
                isLhp={isLhp}
                isLoadingAvg={isLoadingAvg}
            />
        ),
    }];

    const [activeTabKey, setActiveTabKey] = useState(tabs[0].key);
    const onTabSelect = ({ key }) => setActiveTabKey(key);
    const activeTab = tabs.find(({ key }) => key === activeTabKey);

    return (
        <StyledTabsWrapper className={className}>
            <TabContainer>
                {tabs.map((t) => {
                    const { key, title, ...rest } = t;
                    return (<Tab key={key} active={t === activeTab} onClick={() => onTabSelect(t)} {...rest}>{title}</Tab>);
                })}
            </TabContainer>
            <TabPanel>{activeTab && activeTab.component()}</TabPanel>
        </StyledTabsWrapper>
    );
};

export default PitchTabs;
